export default __webpack_public_path__ + "6c29db077c0c383f6c1305eab1fbce0e.png";